module.exports = __webpack_public_path__ + "static/media/grand-land.ff6a3e38.gif";